/* eslint-disable */
import React, { Component } from 'react';
import NavigationBar from '../NavigationBar';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpened: false,
        };
        this.toggleMenu = this.toggleMenu.bind(this);
    }

    toggleMenu() {
        const { isOpened } = this.state;
        this.setState({
            isOpened: !isOpened,
        });
    }

    render() {
        const { isOpened } = this.state;
        return (
            <div className="mobile-header">
                <div
                    className={`mobile-header__bar ${
                        isOpened ? 'mobile-header__bar--fixed' : ''
                    }`}
                >
                    <div className="mobile-header__logo">
                        <a>
                            <img
                                alt="Logo white"
                                src="/static/images/logo-white.png"
                            />
                        </a>
                    </div>
                    <div
                        className="mobile-header__menu-trigger"
                        onClick={this.toggleMenu}
                    >
                        {(() => {
                            if (isOpened) {
                                return <i className="icon icon-close2" />;
                            }
                            return <span>Menu</span>;
                        })()}
                    </div>
                </div>
                <div
                    className={`mobile-header__overlay ${
                        isOpened ? 'mobile-header__overlay--shown' : ''
                    }`}
                />
                <div
                    className={`mobile-header__menu ${
                        isOpened ? 'mobile-header__menu--shown' : ''
                    }`}
                >
                    <div className="navigation-container">
                        <NavigationBar />
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;
